import { logError } from 'fergy-core-react-logging';
import { useEffect, useState } from 'react';
import useScript from 'react-script-hook';
import { doesWindowExist } from '../../utils/dom/dom.utils';

const MEDALLIA_SCRIPT = 'https://nebula-cdn.kampyle.com/us/wu/1193605/onsite/embed.js';

export const useMedallia = (formId: number) => {
	useScript({
		src: doesWindowExist() && window.dataLayer?.isBot ? null : MEDALLIA_SCRIPT,
		checkForExisting: true
	});
	const [isMedalliaLoaded, setIsMedalliaLoaded] = useState(false);

	const openMedalliaForm = () => {
		window.KAMPYLE_ONSITE_SDK.showForm(formId);
	};

	const onMedalliaLoaded = () => {
		const formLoaded = window.KAMPYLE_ONSITE_SDK.loadForm(formId);
		if (formLoaded) {
			setIsMedalliaLoaded(true);
		} else {
			logError(`Unable to load medallia form ${formId}`);
		}
	};

	useEffect(() => {
		const handleMedalliaLoad = () => {
			onMedalliaLoaded();
		};

		if (window.KAMPYLE_ONSITE_SDK) {
			onMedalliaLoaded();
		} else {
			window.addEventListener('neb_OnsiteLoaded', handleMedalliaLoad);
		}
		return () => {
			window.removeEventListener('neb_OnsiteLoaded', handleMedalliaLoad);
		};
	}, []);

	return { openMedalliaForm, isMedalliaLoaded };
};
